window.angular.module('hippo').directive('stateLicenses', function (HIPPO_CONSTS, featureToggle, licenseService) {
    'ngInject';
    return {
        restrict: 'E',
        replace: false,
        template: `
      <p class="carriers">*Hippo Insurance Services (“Hippo”) is a general agent for affiliated and non-affiliated insurance companies. Hippo is licensed as a property casualty insurance agency in all states in which products are offered.</p>                                                                      
      <p class="carriers">Policies provided by Hippo in {{topaString}} are underwritten by <a href="https://www.topains.com/" target="_blank">Topa Insurance Company</a></p>
      <p class="carriers">Policies provided by Hippo in in {{spinnakerString}} are underwritten by <a href="https://www.spinnakerins.com/" target="_blank">Spinnaker Insurance Company</a></p>
      <p class="carriers">Hippo surplus lines policies in {{canopiusString}} are underwritten by <a href="https://www.canopius.com/insurance/" target="_blank">Canopius US Insurance, Inc.</a></p>
        `,
        scope: {},
        link: function ($scope) {
            const carriers = HIPPO_CONSTS.CARRIERS;
            const carrierToStateMap = licenseService.getCarrierToStateMap();
            $scope.topaString = licenseService.convertArrayToSentenceList(carrierToStateMap[carriers.TOPA]);
            $scope.spinnakerString = licenseService.convertArrayToSentenceList(carrierToStateMap[carriers.SPINNAKER]);
            $scope.canopiusString = licenseService.convertArrayToSentenceList(carrierToStateMap[carriers.CANOPIUS]);
        }
    };
});
